import { render, staticRenderFns } from "./manipulacaoItensEmbalagens.vue?vue&type=template&id=2318d1c6&class=crud-item-grid"
import script from "./manipulacaoItensEmbalagens.ts?vue&type=script&lang=js&external"
export * from "./manipulacaoItensEmbalagens.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2318d1c6')) {
      api.createRecord('2318d1c6', component.options)
    } else {
      api.reload('2318d1c6', component.options)
    }
    module.hot.accept("./manipulacaoItensEmbalagens.vue?vue&type=template&id=2318d1c6&class=crud-item-grid", function () {
      api.rerender('2318d1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacaoNew/manipulacaoItensEmbalagens/manipulacaoItensEmbalagens.vue"
export default component.exports